import React from "react";
import "../Ticket.css";

export default function Modal({
    open,
    title,
    onClose,
    children,
}: {
    open: boolean;
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}) {
    if (!open) return null;

    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 16,
                zIndex: 9999,
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    width: "min(900px, 95vw)",
                    maxHeight: "90vh",
                    overflow: "auto",
                    background: "#fff",
                    borderRadius: 12,
                    boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                    border: "1px solid rgba(0,0,0,0.12)",
                }}
            >
                <div
                    style={{
                        padding: "12px 16px",
                        borderBottom: "1px solid #eee",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 12,
                    }}
                >
                    <div style={{ fontWeight: 800 }}>{title}</div>
                    <button className="cancel-btn" onClick={onClose}>
                        Luk
                    </button>
                </div>

                <div style={{ padding: 16 }}>{children}</div>
            </div>
        </div>
    );
}